import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import Viewport from '../ComControl/Viewport'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'

class GoodsLimiteDetailPageModel {
    // 详情页底板
    public DetailGraph: FileName = new FileName({ type: FileName.DEF_TYPE, name: '菜单界面.png' })

    // 预览图底板
    public PreviewBackGraph = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城_商品背景图.png' })

    public PreviewBack_X: number = 0 // 预览图底板X坐标
    public PreviewBack_Y: number = 0 // 预览图底板Y坐标
    public PreviewBack_W: number = 1 // 预览图底板宽度
    public PreviewBack_H: number = 1 // 预览图底板高度
    public Preview_X: number = 0 // 预览图X坐标
    public Preview_Y: number = 0 // 预览图Y坐标
    public Preview_W: number = 1 // 预览图宽度
    public Preview_H: number = 1 // 预览图高度
    public GoodsName_X: number = 0 // 商品名称X坐标
    public GoodsName_Y: number = 0 // 商品名称Y坐标
    public FlowerTotal_X: number = 0 // 总价X坐标
    public FlowerTotal_Y: number = 0 // 总价Y坐标
    public Flower_X: number = 0 // 鲜花图片X坐标
    public Flower_Y: number = 0 // 鲜花图片Y坐标
    public GoodsPrice_X: number = 0 // 商品价格X坐标
    public GoodsPrice_Y: number = 0 // 商品价格Y坐标
    public GoodsIntroView: Viewport = new Viewport() // 商品简介视窗信息
    public Ok_btn: AvgButtonIndex = new AvgButtonIndex() // 确认按钮
    public Cancel_btn: AvgButtonIndex = new AvgButtonIndex() // 取消按钮
    public Add_btn: AvgButtonIndex = new AvgButtonIndex() // 增加按钮
    public Minus_btn: AvgButtonIndex = new AvgButtonIndex() // 减少按钮
    public IsUseImageIndex: boolean = false // 购买数量是否使用图片索引
    public Index: number = 0 // 购买数量的索引
    public IndexImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // 当前索引的图片
    public BuyCount_X: number = 0 // 购买数量X坐标
    public BuyCount_Y: number = 0 // 购买数量Y坐标
    public LimitTime_X: number = 0 // 时间X坐标
    public LimitTime_Y: number = 0 // 时间Y坐标
    public SaleCount_X: number = 0 // 售卖数量X坐标
    public SaleCount_Y: number = 0 // 售卖数量Y坐标
    public IsShowBuyCount: boolean = true // 是否显示购买数量
    public IsShowGoodsName: boolean = true // 是否显示商品名称
    public IsShowGoodsIntro: boolean = true // 是否显示商品简介
    public IsShowGoodsImage: boolean = true // 是否显示商品图片
    public IsShowLimitTime: boolean = true // 是否显示售卖限时
    public IsShowSaleCount: boolean = true // 是否显示售卖数量

    readVersionedOui(reader: FileReader): void {
        this.DetailGraph.readVersionedOui(reader.readObj(reader.readInt()))
        this.PreviewBackGraph.readVersionedOui(reader.readObj(reader.readInt()))

        this.PreviewBack_X = reader.readInt()
        this.PreviewBack_Y = reader.readInt()
        this.PreviewBack_W = reader.readInt()
        this.PreviewBack_H = reader.readInt()

        this.Preview_X = reader.readInt()
        this.Preview_Y = reader.readInt()
        this.Preview_W = reader.readInt()
        this.Preview_H = reader.readInt()

        this.GoodsName_X = reader.readInt()
        this.GoodsName_Y = reader.readInt()

        this.FlowerTotal_X = reader.readInt()
        this.FlowerTotal_Y = reader.readInt()

        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()

        this.GoodsPrice_X = reader.readInt()
        this.GoodsPrice_Y = reader.readInt()

        this.GoodsIntroView.readVersionedOui(reader.readObj(reader.readInt()))
        this.Ok_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Cancel_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Minus_btn.readVersionedOui(reader.readObj(reader.readInt()))
        this.Add_btn.readVersionedOui(reader.readObj(reader.readInt()))

        this.IsUseImageIndex = Boolean(reader.readInt())

        this.Index = reader.readInt()
        this.IndexImage.readVersionedOui(reader.readObj(reader.readInt()))

        this.BuyCount_X = reader.readInt()
        this.BuyCount_Y = reader.readInt()

        this.LimitTime_X = reader.readInt()
        this.LimitTime_Y = reader.readInt()

        this.SaleCount_X = reader.readInt()
        this.SaleCount_Y = reader.readInt()

        this.IsShowBuyCount = Boolean(reader.readInt())
        this.IsShowGoodsName = Boolean(reader.readInt())
        this.IsShowGoodsIntro = Boolean(reader.readInt())
        this.IsShowGoodsImage = Boolean(reader.readInt())
        this.IsShowLimitTime = Boolean(reader.readInt())
        this.IsShowSaleCount = Boolean(reader.readInt())

        // 为了始终限时这两项，要是改成动态的话就删掉
        this.IsShowLimitTime = true
        this.IsShowSaleCount = true
    }
    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        this.DetailGraph.writeVersionedOui(writer)
        this.PreviewBackGraph.writeVersionedOui(writer)
        writer.writeInt(this.PreviewBack_X)
        writer.writeInt(this.PreviewBack_Y)
        writer.writeInt(this.PreviewBack_W)
        writer.writeInt(this.PreviewBack_H)
        writer.writeInt(this.Preview_X)
        writer.writeInt(this.Preview_Y)
        writer.writeInt(this.Preview_W)
        writer.writeInt(this.Preview_H)
        writer.writeInt(this.GoodsName_X)
        writer.writeInt(this.GoodsName_Y)
        writer.writeInt(this.FlowerTotal_X)
        writer.writeInt(this.FlowerTotal_Y)
        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.GoodsPrice_X)
        writer.writeInt(this.GoodsPrice_Y)
        this.GoodsIntroView.writeVersionedOui(writer)
        this.Ok_btn.writeVersionedOui(writer)
        this.Cancel_btn.writeVersionedOui(writer)
        this.Minus_btn.writeVersionedOui(writer)
        this.Add_btn.writeVersionedOui(writer)
        writer.writeInt(this.IsUseImageIndex ? 1 : 0)
        writer.writeInt(this.Index)
        this.IndexImage.writeVersionedOui(writer)
        writer.writeInt(this.BuyCount_X)
        writer.writeInt(this.BuyCount_Y)
        writer.writeInt(this.LimitTime_X)
        writer.writeInt(this.LimitTime_Y)
        writer.writeInt(this.SaleCount_X)
        writer.writeInt(this.SaleCount_Y)

        writer.writeInt(this.IsShowBuyCount ? 1 : 0)
        writer.writeInt(this.IsShowGoodsName ? 1 : 0)
        writer.writeInt(this.IsShowGoodsIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodsImage ? 1 : 0)
        writer.writeInt(this.IsShowLimitTime ? 1 : 0)
        writer.writeInt(this.IsShowSaleCount ? 1 : 0)

        writer.writerLength()
    }
}
export default GoodsLimiteDetailPageModel
